export function formatCurrency(number, currency = 'USD', locale = 'en-US') {
    return new Intl.NumberFormat(locale, {
        // style: 'currency',
        currency: currency,
    }).format(number);
}

export const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
};
